import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DeleteFileParams } from "../../../../../types/product-card-files.types";
import { ListingFilesStateService } from "../../services/listing-files-state.service";
import { ListingFilesModalService } from "../../services/listing-files-modal.service";
import { ListingFileData } from "../../types/listing-file-data.types";
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";
import { ListingFilesSyncService } from "../../services/listing-files-sync.service";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { FileCardComponent } from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import { ListingPathStateService } from "../../services/listing-path-state.service";

@Component({
  selector: 'app-listing-file-library',
  standalone: true,
  imports: [
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
    MatTooltip,
    MatIcon,
    FileCardComponent
  ],
  templateUrl: './listing-file-library.component.html',
  styleUrl: './listing-file-library.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingFileLibraryComponent {
  isEditModeActive = input<boolean>(false);
  modalKey = input<string>("listings");
  getFiles = output<void>();

  public listingFilesStateService: ListingFilesStateService = inject(ListingFilesStateService);
  private listingFilesModalService: ListingFilesModalService = inject(ListingFilesModalService);
  private listingFilesSyncService: ListingFilesSyncService = inject(ListingFilesSyncService);
  private listingPathStateService: ListingPathStateService = inject(ListingPathStateService);

  public handleDelete(isImage: boolean, file: ListingFileData): void {
    const params: DeleteFileParams = {
      path: this.listingPathStateService.pathState(),
      id: file.id
    };

    this.listingFilesModalService.deleteFile(params)
      .then(() => this.listingFilesStateService.deleteFileById(file.id));
  }

  public async handleDrop(event: CdkDragDrop<Array<ListingFileData>>): Promise<void> {
    const oldFiles = this.listingFilesStateService.listingFilesState();
    const newFiles = [...oldFiles];
    moveItemInArray(newFiles, event.previousIndex, event.currentIndex);

    const updatedFiles = newFiles.map((file, index) => ({
      ...file,
      uspPriority: index + 1
    }));

    this.listingFilesStateService.setListingFilesState(updatedFiles);
    const draggedFile = updatedFiles[event.currentIndex];
    await this.listingFilesSyncService.updateFilePriority(
      draggedFile.id,
      draggedFile.uspPriority
    );

    this.getFiles.emit();
  }
}
